import { z } from 'zod'
import { DEFAULT_LANGUAGE, LANGUAGES } from '../i18n'
import { resolveApiUrl } from '../runtime-config'

export const AppMetaSchema = z.object({
	version: z.string().default('0'),
})

export const UserPreferencesSchema = z.object({
	language: z.enum(LANGUAGES).default(DEFAULT_LANGUAGE),
	tableState: z
		.object({
			pageSize: z.number().int().min(1).max(100).default(20),
		})
		.default({ pageSize: 20 }),
})

export const DEFAULT_API_ENDPOINT = resolveApiUrl(
	window.__TEZGO_CONFIG__,
	import.meta.env
)

export const DEFAULT_ENDPOINT_LIST = [
	DEFAULT_API_ENDPOINT,
	...(import.meta.env.DEV ? ['http://192.168.0.103:7778'] : []),
]

export const DevSchema = z.object({
	apiEndpoints: z.array(z.string().url()).default(DEFAULT_ENDPOINT_LIST),
	selectedApiEndpoint: z.string().url().default(DEFAULT_API_ENDPOINT),
})

export const DEV_STORAGE_DEFAULTS = DevSchema.parse({})

export const StorageSchemas = {
	'app-meta': AppMetaSchema,
	'user-preferences': UserPreferencesSchema,
	dev: DevSchema,
} as const

export type StorageKey = keyof typeof StorageSchemas
export type StorageValue<K extends StorageKey> = z.infer<
	(typeof StorageSchemas)[K]
>
